import { render, staticRenderFns } from "./UserDirectory.vue?vue&type=template&id=6929b7ec&scoped=true"
import script from "./UserDirectory.vue?vue&type=script&lang=js"
export * from "./UserDirectory.vue?vue&type=script&lang=js"
import style0 from "./UserDirectory.vue?vue&type=style&index=0&id=6929b7ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6929b7ec",
  null
  
)

export default component.exports